<script setup>
import { provide, ref } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "multiple",
  },
  defaultValue: {
    type: [String, Array],
    default: () => [],
  },
});

const openItems = ref(
    props.type === "single"
        ? (Array.isArray(props.defaultValue)
            ? props.defaultValue[0]
            : props.defaultValue)
            ? [props.defaultValue]
            : []
        : Array.isArray(props.defaultValue)
            ? props.defaultValue
            : []
);

const toggleItem = (id) => {
  if (props.type === "single") {
    openItems.value = openItems.value[0] === id ? [] : [id];
  } else {
    openItems.value = openItems.value.includes(id)
        ? openItems.value.filter((v) => v !== id)
        : [...openItems.value, id];
  }
};

provide("accordion", {
  openItems,
  toggleItem,
});
</script>

<template>
  <div class="w-full space-y-2">
    <slot />
  </div>
</template>

<style scoped>
.w-full {
  width: 100%;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}
</style>